<template>
  <div>
    <div></div>
    <div></div>
    <div>
      <label>订货编号：</label>
      <span></span>
    </div>
    <div>
      <label>发货日期：</label>
      <span></span>
    </div>
    <div>
      <div></div>
      <div></div>
    </div>
    <div>立即加购</div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
